import { render, staticRenderFns } from "./SBox.vue?vue&type=template&id=18695cff&scoped=true&"
var script = {}
import style0 from "./SBox.vue?vue&type=style&index=0&id=18695cff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18695cff",
  null
  
)

export default component.exports